
import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { useRecoilValue } from "recoil";  
import { atom_tourState } from "@app/shared/state/tour.atom";

interface TopicButtonProps {
  text: string;
  onClick: () => void;
}

const TopicButton: React.FC<TopicButtonProps> = ({ text, onClick }) => (
  <Button
    onClick={onClick}
    variant="outlined"
    sx={{
      border: "1px solid #2A1004",
      color: "#312F2E",
      fontSize: { xs: "13px", sm: "14px" },
      px: { xs: 1.25, sm: 1.5 },
      py: { xs: 0.75, sm: 1 },
      bgcolor: "rgba(7,54,116,0.10)",
      borderRadius: "20px",
      textTransform: "none",
      "&:hover": {
        bgcolor: "rgba(7,54,116,0.15)",
        border: "1px solid #2A1004",
      }
    }}
  >
    {text}
  </Button>
);

interface TopicsGridProps {
  onSelectTopic: (topic: string) => void;
}

export const TopicsGrid: React.FC<TopicsGridProps> = ({ onSelectTopic }) => {
  const tour = useRecoilValue(atom_tourState);
  const topics = tour?.AIqus || [];

  const handleTopicClick = (topic: string) => {
    onSelectTopic(topic);
  };

  return (
    <>
    {topics.length > 0 && (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
      <Typography variant="h6" sx={{ textAlign: "center",fontSize: 14 }}>
        You can select one of these questions
      </Typography>
      <Box 
        sx={{ 
          display: "flex", 
          flexWrap: "wrap", 
          gap: { xs: 0.75, sm: 1 }, 
          justifyContent: "center", 
          mt: 1 
        }}
      >
        {topics.map((topic, index) => (
          <TopicButton
            key={index}
            text={topic}
            onClick={() => handleTopicClick(topic)}
          />
        ))}
      </Box>
    </Box>
    )
    }
    </>
  );
};